import { Chat } from './chat';
import { Habitat } from './habitat';
import { Map } from './map';
import Misc from './misc';
import { Schedule } from './schedule';
import { Zoo } from './zoo';
// TODO - export Permission type
export const Permission = { Habitat, Map, Chat, Schedule, Zoo, ...Misc };
